var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c("NOSComponent", {
        ref: "NOS_COMPONENT",
        attrs: { component: this.NOS_INSTANCE.components }
      }),
      _c(
        "div",
        { staticClass: "scroll" },
        [
          _c("contents-header", {
            attrs: {
              "bg-type": true,
              "no-radius": true,
              title: "MOTP-01-06-01-01",
              description: "MOTP-01-06-01-02"
            }
          }),
          _c("div", { staticClass: "contents" }, [
            _c("div", { staticClass: "cont-tit" }, [
              _c("h6", [
                _vm._v(_vm._s(/*mOTP 정보*/ _vm.$t("MOTP-01-06-01-03")))
              ])
            ]),
            _c("dl", { staticClass: "dlist dlist-item--type2" }, [
              _c("dt", [_vm._v(_vm._s(/*아이디*/ _vm.$t("MOTP-01-06-01-04")))]),
              _vm.$store.state.sessionInfo.userInfo.userIdnfr !== ""
                ? _c("dd", [
                    _vm._v(
                      _vm._s(_vm.$store.state.sessionInfo.userInfo.userIdnfr)
                    )
                  ])
                : _vm._e(),
              _c("dt", [_vm._v(_vm._s(/*국가*/ _vm.$t("MOTP-01-06-01-05")))]),
              _c("dd", [
                _vm._v(_vm._s(_vm.$t(_vm.$store.state.siteCode + "_국가명")))
              ]),
              _c("dt", [_vm._v(_vm._s(/*발급일*/ _vm.$t("MOTP-01-06-01-06")))]),
              _c("dd", [
                _vm._v(
                  _vm._s(
                    _vm.$getGlobalDateYmd(
                      _vm.$store.state.auth.changeMotpPin.certnMotpId.out
                        .success.issuncYMS
                    )
                  )
                )
              ])
            ]),
            _c("form", { staticClass: "form" }, [
              _c("div", { staticClass: "notice notice-box--type" }, [
                _c("div", { staticClass: "notice-tit" }, [
                  _c("p", { staticClass: "bullet" }, [
                    _vm._v(_vm._s(/*유의사항*/ _vm.$t("MOTP-01-06-01-07")))
                  ])
                ]),
                _c("div", { staticClass: "notice-cont" }, [
                  _c("strong", {
                    domProps: { innerHTML: _vm._s(_vm.$t("MOTP-01-06-01-08")) }
                  }),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("MOTP-01-06-01-09")) }
                  })
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c("div", { staticClass: "btn-area--full fixed" }, [
        _c(
          "button",
          { staticClass: "btn md normal", on: { click: _vm.FN001 } },
          [_vm._v(_vm._s(/*인증하기*/ _vm.$t("MOTP-01-06-01-10")))]
        )
      ]),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened: _vm.type3,
          "modal-header": true,
          "modal-footer": true,
          title: "mOTP PIN를 잊어버린 경우"
        },
        on: {
          "update:opened": function($event) {
            _vm.type3 = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.$t("MOTP-01-06-01-08")) }
                  })
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom negative",
                    on: {
                      click: function($event) {
                        _vm.type3 = !_vm.type3
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*취소*/ _vm.$t("MCOM-0000002")))]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: { click: _vm.FN002 }
                  },
                  [
                    _vm._v(
                      _vm._s(/*PIN번호 분실 변경*/ _vm.$t("MOTP-01-06-03-05"))
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("approval-line", {
        ref: "approvalLine",
        attrs: { NOS_INSTANCE_REFERANCE: _vm.NOS_INSTANCE }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }